import React from 'react';
import { Instagram, Twitter, Facebook, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-[#F5F5F0]/5 pt-20 pb-10" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-29">
          {/* Brand */}
          <div className="space-y-6" data-id="element-30">
            <a href="#" className="text-2xl font-bold font-serif tracking-wider text-[#F5F5F0]" data-id="element-31">
              GAMERIE<span className="text-[#C9A962]" data-id="element-32">.</span>
            </a>
            <p className="text-[#F5F5F0]/50 text-sm leading-relaxed" data-id="element-33">
              The premier destination for authenticated gaming collectibles and
              limited edition merchandise. Curated for the true enthusiast.
            </p>
            <div className="flex space-x-4" data-id="element-34">
              <a href="#" className="text-[#F5F5F0]/60 hover:text-[#C9A962] transition-colors" data-id="element-35">
                <Instagram size={20} data-id="element-36" />
              </a>
              <a href="#" className="text-[#F5F5F0]/60 hover:text-[#C9A962] transition-colors" data-id="element-37">
                <Twitter size={20} data-id="element-38" />
              </a>
              <a href="#" className="text-[#F5F5F0]/60 hover:text-[#C9A962] transition-colors" data-id="element-39">
                <Facebook size={20} data-id="element-40" />
              </a>
              <a href="#" className="text-[#F5F5F0]/60 hover:text-[#C9A962] transition-colors" data-id="element-41">
                <Youtube size={20} data-id="element-42" />
              </a>
            </div>
          </div>

          {/* Collections */}
          <div data-id="element-43">
            <h4 className="text-[#F5F5F0] font-serif text-lg mb-6" data-id="element-44">
              Collections
            </h4>
            <ul className="space-y-4 text-sm text-[#F5F5F0]/60" data-id="element-45">
              <li data-id="element-46">
                <a href="#" className="hover:text-[#C9A962] transition-colors" data-id="element-47">
                  Obsidian Vault
                </a>
              </li>
              <li data-id="element-48">
                <a href="#" className="hover:text-[#C9A962] transition-colors" data-id="element-49">
                  Meridian Series
                </a>
              </li>
              <li data-id="element-50">
                <a href="#" className="hover:text-[#C9A962] transition-colors" data-id="element-51">
                  Aureate Collection
                </a>
              </li>
              <li data-id="element-52">
                <a href="#" className="hover:text-[#C9A962] transition-colors" data-id="element-53">
                  Ecliptic Drops
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div data-id="element-54">
            <h4 className="text-[#F5F5F0] font-serif text-lg mb-6" data-id="element-55">Support</h4>
            <ul className="space-y-4 text-sm text-[#F5F5F0]/60" data-id="element-56">
              <li data-id="element-57">
                <a href="#" className="hover:text-[#C9A962] transition-colors" data-id="element-58">
                  Authenticity Check
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-[#C9A962] transition-colors" data-id="element-60">
                  Shipping & Returns
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="hover:text-[#C9A962] transition-colors" data-id="element-62">
                  FAQ
                </a>
              </li>
              <li data-id="element-63">
                <a href="#" className="hover:text-[#C9A962] transition-colors" data-id="element-64">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-65">
            <h4 className="text-[#F5F5F0] font-serif text-lg mb-6" data-id="element-66">Contact</h4>
            <ul className="space-y-4 text-sm text-[#F5F5F0]/60" data-id="element-67">
              <li data-id="element-68">Limassol, Cyprus</li>
              <li data-id="element-69">support@gamerie.com</li>
              <li className="pt-4 text-[#C9A962]" data-id="element-70">
                Zenith Tier Members Line Available 24/7
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#F5F5F0]/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-71">
          <p className="text-[#F5F5F0]/30 text-xs" data-id="element-72">
            © 2026 Gamerie. All rights reserved.
          </p>
          <div className="flex space-x-6 text-[#F5F5F0]/30 text-xs" data-id="element-73">
            <a href="#" className="hover:text-[#F5F5F0] transition-colors" data-id="element-74">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-[#F5F5F0] transition-colors" data-id="element-75">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}